import { View } from 'react-native'
import { Customer } from '@ca/common/types'
import Icon from '@ui/elements/Icon'
import Typography from '@ui/typography'
import { colors } from '@ui/colors'
import { leadingNone } from '@ui/typography/styles'
import cn from '@ui/utils/cn'
import { StatusProps } from '@ui/elements/Status/types'
import Status from '@ui/elements/Status'
import Gradient from '@ui/effects/Gradient'
import { borderRadius } from './CustomerCard'

interface Props {
  data: Pick<Customer, 'first_name' | 'last_name' | 'ref'>
  badges?: StatusProps[]
  standalone?: boolean
}

export default function CustomerHeader({
  data,
  badges,
  standalone = false,
}: Props) {
  const { first_name, last_name, ref } = data

  return (
    <View>
      {!standalone && (
        <Gradient
          colors={[colors.gray[75], colors.gray[50]]}
          start={[0, 0.5]}
          end={[1, 0.5]}
          style={{
            borderTopLeftRadius: borderRadius,
            borderTopRightRadius: borderRadius,
            borderBottomLeftRadius: standalone ? borderRadius : 0,
            borderBottomRightRadius: standalone ? borderRadius : 0,
          }}
        />
      )}

      <View className="flex flex-row items-center gap-8 px-8 py-10">
        <View className="flex h-8 w-8 items-center justify-center">
          <Icon name="user-circle" color={colors.neutral[900]} />
        </View>
        <View className="h-8 flex-1 flex-row items-center gap-4">
          <Typography variant="MDB" className={leadingNone}>
            {first_name} {last_name}
          </Typography>
          <Typography variant="MD" className={cn(leadingNone, 'text-desc')}>
            {ref}
          </Typography>
        </View>
        {badges && badges.length > 0 && (
          <View className="flex-row gap-2">
            {badges.map((status, i) => (
              <Status key={i} {...status} />
            ))}
          </View>
        )}
      </View>
    </View>
  )
}
